import React from "react";

const ArjunCard4 = props => {
  return (
    <div className="tc bg-lightest-yellow dib br3 pa3 ma2 grow bw2 shadow-5">
      <h2>{props.name}</h2> <h3>Kitten</h3>
      <img
        alt="robot"
        src={`https://robohash.org/${props.name}1?set=set4&size=150x150`}
      />
    </div>
  );
};

export default ArjunCard4;
